import { c as _c } from "react/compiler-runtime";
import { CARD_IMAGE_ASPECT, type CardImageAspect } from "@/components/storefront/card-image-aspect";
import { Skeleton } from "@/components/storefront/ui/skeleton";
export function ProductCardSkeleton(t0) {
  const $ = _c(14);
  let t1;
  if ($[0] !== t0) {
    t1 = t0 === undefined ? {} : t0;
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    imageAspect: t2,
    withAction: t3
  } = t1;
  const imageAspect = t2 === undefined ? "portrait" : t2;
  const withAction = t3 === undefined ? false : t3;
  const t4 = `${CARD_IMAGE_ASPECT[imageAspect]} w-full rounded-2xl`;
  let t5;
  if ($[2] !== t4) {
    t5 = <Skeleton className={t4} />;
    $[2] = t4;
    $[3] = t5;
  } else {
    t5 = $[3];
  }
  let t6;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <Skeleton className="h-4 w-3/4" />;
    $[4] = t6;
  } else {
    t6 = $[4];
  }
  let t7;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <div className="flex items-center gap-2"><Skeleton className="h-4 w-16" /><Skeleton className="h-4 w-12" /></div>;
    $[5] = t7;
  } else {
    t7 = $[5];
  }
  let t8;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <div className="flex items-center gap-1.5 pt-1"><Skeleton className="h-4 w-4 rounded-full" /><Skeleton className="h-4 w-4 rounded-full" /><Skeleton className="h-4 w-4 rounded-full" /></div>;
    $[6] = t8;
  } else {
    t8 = $[6];
  }
  let t9;
  if ($[7] !== withAction) {
    t9 = withAction && <Skeleton className="h-10 w-full rounded-xl" />;
    $[7] = withAction;
    $[8] = t9;
  } else {
    t9 = $[8];
  }
  let t10;
  if ($[9] !== t9) {
    t10 = <div className="mt-3 px-0.5 space-y-2">{t6}{t7}{t8}{t9}</div>;
    $[9] = t9;
    $[10] = t10;
  } else {
    t10 = $[10];
  }
  let t11;
  if ($[11] !== t10 || $[12] !== t5) {
    t11 = <div className="flex flex-col">{t5}{t10}</div>;
    $[11] = t10;
    $[12] = t5;
    $[13] = t11;
  } else {
    t11 = $[13];
  }
  return t11;
}
export function ProductGridSkeleton(t0) {
  const $ = _c(6);
  const {
    count: t1,
    imageAspect: t2,
    withAction: t3
  } = t0;
  const count = t1 === undefined ? 8 : t1;
  const imageAspect = t2 === undefined ? "portrait" : t2;
  const withAction = t3 === undefined ? false : t3;
  let t4;
  if ($[0] !== count) {
    t4 = Array.from({
      length: count
    });
    $[0] = count;
    $[1] = t4;
  } else {
    t4 = $[1];
  }
  let t5;
  if ($[2] !== imageAspect || $[3] !== t4 || $[4] !== withAction) {
    t5 = <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">{t4.map((_, i) => <ProductCardSkeleton key={i} imageAspect={imageAspect} withAction={withAction} />)}</div>;
    $[2] = imageAspect;
    $[3] = t4;
    $[4] = withAction;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  return t5;
}